<template>
  <NuxtLayout>
    <section class="container mx-auto px-4 md:px-8 py-16 text-center">
      <!-- <p class="uppercase tracking-widest text-sm text-gray-500 mb-2">
        {{ status }} • {{ is404 ? "not found" : "error" }}
      </p> -->

      <h1 class="text-3xl md:text-4xl font-bold mb-3">
        {{ is404 ? "Сторінку не знайдено" : "Сталася помилка" }}
      </h1>

      <p class="text-gray-600 max-w-xl mx-auto mb-8">
        {{ description }}
      </p>

      <div class="flex flex-wrap items-center justify-center gap-3">
        <button
          class="px-5 py-3 rounded-xl font-semibold bg-pink-200 text-black hover:bg-pink-200/80"
          @click="goHome"
        >
          На головну
        </button>
        <button
          class="px-5 py-3 rounded-xl border hover:bg-gray-50"
          @click="goCatalog"
        >
          До каталогу
        </button>
        <button
          v-if="!is404"
          class="px-5 py-3 rounded-xl border hover:bg-gray-50"
          @click="tryAgain"
        >
          Спробувати ще раз
        </button>
      </div>

      <!-- технічні деталі для дебагу (лише у dev) -->
      <!-- <pre
        v-if="dev && details"
        class="mt-8 text-left inline-block bg-gray-50 p-4 rounded-lg overflow-auto max-w-full"
        >{{ details }}
      </pre> -->
    </section>
  </NuxtLayout>
</template>

<script setup>
import { computed } from "vue";
import { useError, clearError } from "#app";
import { useHead } from "#imports";

const err = useError();
const status = computed(() => Number(err.value?.statusCode || 500));
const is404 = computed(() => status.value === 404);
const description = computed(() =>
  is404.value
    ? "На жаль, такої сторінки не існує або вона була переміщена."
    : err.value?.message || "Нам шкода, але щось пішло не так.",
);

const dev = import.meta.dev;
const details = computed(() => (dev ? JSON.stringify(err.value, null, 2) : ""));

useHead({
  title: `${status.value} — ${
    is404.value ? "Сторінку не знайдено" : "Сталася помилка"
  }`,
  meta: [{ name: "robots", content: "noindex" }],
});

function goHome() {
  clearError({ redirect: "/" });
}
function goCatalog() {
  clearError({ redirect: "/catalog" });
}
function tryAgain() {
  if (import.meta.client) window.location.reload();
}

console.error(details);
</script>
